module.exports = __webpack_public_path__ + "static/grafika11-d0125bceb2b2f4822b81bfd7e5815f49.png";